import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';

import { Dispatch } from 'src/configs/store';
import { getFlag } from 'src/utils/utils';
import { ReactComponent as Lotto } from 'src/assets/images/numbersbetting/LOTTO.svg';
import logo2 from '../../../assets/images/betxchange-logo2.png';
import DetailHeaderContext from '../Context/DetailHeader.context';
import Icon from 'src/components/Icon/Icon';
import useIsMobile from 'src/hooks/useIsMobile';

interface LottoDrawProps {
  /**
   * Portrayed event's information.
   */
  event: {
    countryCode: string,
    country: string,
    name: string,
    description: string,
    imageDesktop: string
    couponCode: number,
    cardCode: string
  }
}

export default function LottoDraw({ event }: LottoDrawProps) {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation('common');
  const dispatch = useDispatch<Dispatch>();

  const [hasOverflow, setHasOverflow]=useState(false);
  const { showInfo, setShowInfo } = useContext(DetailHeaderContext);
  const mobile = useIsMobile();

  const overFlow = useRef(null);

  useEffect(() => {
    //Check if we should display card codde
    if ((mobile && overFlow.current?.offsetHeight > 17)){
      setHasOverflow(true);
    } else {
      setHasOverflow(false);
    }
  }, [showInfo]);

  const toggleInfo = () => {
    setShowInfo(!showInfo);
  };

  const goBack = () => {
    dispatch.events.setEvent({});
    history.push(`/lotto${ location.search }`);
  };

  return (
    <div className={ !mobile ? 'detail-header__lotto-desktop' : 'detail-header__lotto-mobile' }>
      <div className="detail-header__background">
        <Lotto className={
          classNames({
            'detail-header__lotto-icon': true,
            'detail-header__lotto-icon--info': showInfo
          })
        }
        />
      </div>
      <div className="detail-header__header-wrapper">
        <div
          className="detail-header__back"
          onClick={ goBack }
        >
          <Icon icon="arrow" className="detail-header__arrow" />
          { !mobile && <span>{ t('numbers.lobby') }</span> }
        </div>
        <div className={
          classNames({
            'detail-header__title-info': true,
            'detail-header__title-info--big-title': event.name?.length + event.country?.length > 17,
            'detail-header__title-info--show-info': showInfo
          })
        }
        >
          <span
            className={
              classNames({
                'detail-header__tournament-flag': true,
                'detail-header__tournament-flag--big-title': event.name?.length + event.country?.length  > 17,
                'detail-header__tournament-flag--show-info': showInfo
              })
            }
            style={ { backgroundImage: `url(${ getFlag(event.countryCode) })` } }
          />
          <span
            className={
              classNames({
                'detail-header__info-text': true,
                'detail-header__info-text--numbers': true,
                'detail-header__info-text--full': showInfo
              })
            }
            ref={ overFlow }
            title={ event.name }
          >{ `${ event.country } - ${ event.name }` }</span>
        </div>
        {
          mobile &&
        <Icon
          icon={ showInfo ? 'close' : 'info' }
          className={
            classNames({
              'detail-header__close': showInfo,
              'detail-header__information': !showInfo
            })
          }
          onClick={ toggleInfo }
        />
        }
      </div>
      {
        event.cardCode && !hasOverflow && <div className="detail-header__coupon detail-header__coupon--lotto">
          { t('racingDetail.cardCode') }: { event.cardCode }
        </div>
      }
      {
        event.couponCode && !hasOverflow && <div className="detail-header__coupon detail-header__coupon--lotto">
          { t('racingDetail.couponCode') }: { event.couponCode }
        </div>
      }

      {
        (showInfo || !mobile) && (
          <div className="detail-header__description">
            { event.description }
          </div>
        )
      }

      {
        !mobile && (
          <img
            className="detail-header__image"
            src={ event.imageDesktop || logo2 }
            alt={ event.name }
          />
        )
      }
    </div>
  );
}
